import { createApp } from 'vue'
import App from './App.vue'
import appSidebar from './components/Shared/appSidebar.vue'
import appLayout from './components/appLayout.vue'
import appFooter from './components/Shared/appFooter.vue'
import router from './router';
import i18n from './i18n'

import "./assets/styles/bootstrap.min.css"
import "./assets/scripts/bootstrap.bundle.min.js"
import "./assets/scripts/fontawesome.min.js"

import "./assets/styles/sidebars.css";
import "./assets/styles/site.css";
import 'highlight.js/styles/stackoverflow-light.css'
import "./assets/scripts/sidebars.js";
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";


window.$ = window.jQuery = require('jquery');



const app = createApp(App);

app.component("appSidebar",appSidebar)
app.component("appLayout",appLayout)
app.component("appFooter",appFooter)
app.use(router)
app.use(i18n)
app.use(hljsVuePlugin)
app.mount('#app')
